// extracted by mini-css-extract-plugin
export default {"uploadLabel":"LogoCardFormItem_uploadLabel__wE7-a","cardBodyWrapper":"LogoCardFormItem_cardBodyWrapper__8QvLm","text":"LogoCardFormItem_text__jhmVo"};